import { memo } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import NoDataToDisplay from 'highcharts/modules/no-data-to-display';
// import { useNavigate } from "react-router-dom";


NoDataToDisplay(Highcharts);

const BarChartGraph = memo(({title, data, series, color="#20bd41", navigateUrl}) => {
  
    // const navigate = useNavigate();
    const namesArray = data?.map((item, index) => {
        return (item?.imei)
    })
    const valuesArray = data?.map((item, index) => {
        return (item?.distance)
    })

    const getOptions = {
        chart: {
            type: 'column',
            height: 210,
            marginBottom: 60
        },
        title: {
            text: title,
            align: 'left',
            margin: 30,
            style: {
                fontSize: '14px',
                fontWeight: 'bold',
            }
        },
        xAxis: {
            type: 'category',
            categories: namesArray,
            labels: {
                formatter: function() {
                    const len = this.value.length;
                    return '...' + this.value.substr(len-4, 4);
                },
                rotation: 0,
                autoRotation: false
            },
            crosshair: false,
            style: {
                fontSize: '10px',
                fontWeight: 'normal'
            }
        },
        yAxis: {
            min: 0,
            title: {
                text: null,
            },
            labels:{
                style: {
                    fontSize: '10px',
                    fontWeight: 'normal'
                }
            }
        },
        legend: {
            enabled: true,
            align: 'left',
            y: 22,
            itemStyle: {
                fontSize: '12px',  
                fontWeight: 'normal' 
            }
        },
        lang: {
            noData: 'No data for the selected time range'
        },
        noData: {
            useHTML: true,
            style: {
            fontSize: '14px',
            fontWeight: 'normal',
            color: '#8a8a8a', // color of no data message
            },
        },
        tooltip: {
            backgroundColor: "#fafafa",
            borderWidth: 0,
            height: 80,
            padding: 8,
            valueSuffix: '',
            useHTML: true,
            formatter: function () {
                let xLabel = this.series.chart.xAxis[0].categories[this.point.index];
                let yValue = this.y
                return `<div class="text-center" id="tooltip-xlabel"> 
                        <span>${xLabel}</span><br/>
                        <b>${yValue} km</b></div>`;
                }
        },
        credits: {
            enabled: false,
        },
        exporting: {
            enabled: false,
        },
        plotOptions: {
            column: {
                pointPadding: 0.2,
                borderWidth: 0
            }
        },
        series: [
            {
                dataLabels: {
                    enabled: false,
                },
                name: series,
                data: valuesArray,
                color: color
            },
        ]
    };

    // const handleTooltipClick = (value) =>  {
    //     console.log('click')
    //     navigate(navigateUrl, { state: { imei: value } });
    // }

    return (
        <HighchartsReact highcharts={Highcharts} options={getOptions} />
    )
});

export default BarChartGraph;
